import { CatHeading } from '@blocks-react/components/Heading';
import { Conditional } from '../conditional';
import { ServicesOfferedProps } from './types';
import styles from './services-offered.module.scss';
import cx from 'classnames';

export const ServicesOffered = ({
  title,
  servicesOffered = [],
  isStoreLocationOptimizationFlag = false
}: ServicesOfferedProps) => {
  const showServicesOffered =
    Array.isArray(servicesOffered) && !!servicesOffered.length;

  return (
    <Conditional test={showServicesOffered}>
      <CatHeading
        level="h2"
        variant="title-sm"
        className={isStoreLocationOptimizationFlag ? 'mb-3' : ''}
      >
        {title}
      </CatHeading>
      <p
        className={cx(
          styles['services-offered-text'],
          'cat-u-theme-typography-body mb-0 pb-2'
        )}
      >
        {servicesOffered.join(', ')}
      </p>
    </Conditional>
  );
};
